import { colors } from '../colors';

export const theme = {
    colors:{
        primary: colors.PRYMARY,
        primaryDark: '#3a4a8a',
        secondary: colors.SECONDARY,
        tertiary: colors.TERTIARY,
        background: colors.BACKGROUND,
        backgroundLight: colors.BACKGROUND2,
        backgroundGray: colors.BACKGROUND3,
        red: colors.RED,
        green: colors.GREEN,
        white: '#ffffff',
        gray: {
            50: '#f9fafb',
            100: '#f3f4f6',
            200: '#e5e7eb',
            300: '#d1d5db',
            400: '#9ca3af',
            500: '#6b7280',
            600: '#4b5563',
            700: '#374151',
            800: '#1f2937',
            900: '#111827'
        }
    }
}